import { CheckIcon } from '@heroicons/react/outline';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/solid';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import clsx from 'clsx';
import React, { useRef, useState } from 'react';

import RenderIf from '@/components/Common/RenderIf';

import CourseHeading from '../../BookLandingPageComp/landingPage/heading/CourseHeading';
import ButtonDefault, { ButtonVariants } from '../../shared/basic/button';
import { ShouldRender } from '../../shared/basic/ShouldRender';

interface BookDescriptionProps {
  whatYouWillLearn: string[];
}

const CourseDescription: React.FC<BookDescriptionProps> = ({
  whatYouWillLearn,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const contentRef = useRef<HTMLDivElement>(null);
  const screens = useBreakpoint();

  return (
    <div
      style={{
        border: '1px solid #282829',
        position: 'relative',
      }}
      className='relative  rounded-[12px] p-6 overflow-hidden'
    >
      <ShouldRender check={whatYouWillLearn?.length}>
        <CourseHeading heading='What You’ll Learn' />
        <div
          ref={contentRef}
          style={{
            maxHeight: isExpanded
              ? `${contentRef.current?.scrollHeight}px`
              : '200px',
            overflow: 'hidden',
            transition: 'max-height 0.5s ease-in-out',
          }}
          className='grid md:grid-cols-2 gap-x-10 gap-y-4 md:gap-y-6'
        >
          {whatYouWillLearn.map((topic, index) => (
            <div
              key={`${topic}-${index}`}
              className='flex gap-x-3.5 items-center'
            >
              <span className=' rounded-full'>
                <CheckIcon className='md:h-5 h-4 w-4 md:w-5 text-primary' />
              </span>
              <span className='text-xs md:text-sm text-white'>{topic}</span>
            </div>
          ))}
        </div>
        <div
          style={{
            background:
              'linear-gradient(180deg, rgba(0,0,0,0.5018382352941176) 26%, rgba(1,10,16,1) 100%)',
          }}
          className={clsx(
            isExpanded ? 'block' : 'absolute bottom-0 w-full left-0 ',
            '  ',
          )}
        >
          {!isExpanded && whatYouWillLearn.length > 12 && (
            <div className='q w-full h-[50px] lg:h-[100px]'></div>
          )}

          <div
            className={`relative flex justify-start ${!isExpanded ? 'p-4' : 'pt-4 md:py-4'} rounded-b-[12px] bg-black `}
          >
            <ButtonDefault
              size={screens.lg ? 3 : 1}
              rounded={false}
              roundedSm={true}
              onClick={() => setIsExpanded(!isExpanded)}
              variant={ButtonVariants.GRAY}
              className='w-min text-center'
            >
              <span
                className={clsx(
                  'text-white flex text-sm lg:text-base gap-x-2 md:px-4 whitespace-nowrap items-center',
                )}
              >
                {isExpanded ? 'Show Less' : 'Show More'}
                {isExpanded ? (
                  <ChevronUpIcon className='w-5 h-5' />
                ) : (
                  <ChevronDownIcon className='w-5 h-5' />
                )}
              </span>
            </ButtonDefault>
            <RenderIf condition={!isExpanded}>
              <div className='w-full h-[100px] absolute top-[-100px] left-0  bg-gradient-to-t from-black to-transparent' />
            </RenderIf>
          </div>
        </div>
      </ShouldRender>
    </div>
  );
};

export default CourseDescription;
